import { makeStyles } from '@policygenius/mortar';

const styles = makeStyles((theme) => ({
  disclosure: {
    marginTop: theme.spacing('small'),
    textAlign: 'justify',
  },
}));

export default styles;
